const initialState = {
  start_from: '',
  end_on: '',
};
const initialStateForTest = {
  start_from: '',
  end_on: '',
};

export default initialState;
export { initialStateForTest };
